export enum ErrorCode {
  // Generic
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  FORBIDDEN = 'FORBIDDEN',
  NOT_FOUND = 'NOT_FOUND',
  CONFLICT = 'CONFLICT',

  // Authentication
  AUTH_TOKEN_INVALID = 'AUTH_TOKEN_INVALID',
  AUTH_TOKEN_EXPIRED = 'AUTH_TOKEN_EXPIRED',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  AUTH_INSUFFICIENT_PERMISSIONS = 'AUTH_INSUFFICIENT_PERMISSIONS',
  AUTH_CURRENT_PASSWORD_INCORRECT = 'AUTH_CURRENT_PASSWORD_INCORRECT',

  LOGIN_ATTEMPTS_EXCEEDED = 'LOGIN_ATTEMPTS_EXCEEDED',
  LOGIN_COOLDOWN_REQUIRED = 'LOGIN_COOLDOWN_REQUIRED',
  LOGIN_IP_BLOCKED = 'LOGIN_IP_BLOCKED',
  LOGIN_PERMANENT_BLOCK_REQUIRED = 'LOGIN_PERMANENT_BLOCK_REQUIRED',

  AUTH_PENDING_EMAIL_VERIFICATION = 'AUTH_PENDING_EMAIL_VERIFICATION',
  AUTH_PENDING_ADMIN_ACTIVATION = 'AUTH_PENDING_ADMIN_ACTIVATION',
  AUTH_TOKEN_WRONG_TYPE = 'AUTH_TOKEN_WRONG_TYPE',

  // Validation
  VALIDATION_REQUIRED_FIELD = 'VALIDATION_REQUIRED_FIELD',
  VALIDATION_EMPTY_FIELD = 'VALIDATION_EMPTY_FIELD',
  VALIDATION_INVALID_FORMAT = 'VALIDATION_INVALID_FORMAT',
  VALIDATION_INVALID_FORMAT_NUMBER = 'VALIDATION_INVALID_FORMAT_NUMBER',
  VALIDATION_BIRTH_DATE_INVALID = 'VALIDATION_BIRTH_DATE_INVALID',
  VALIDATION_BIRTH_DATE_UNDERAGE = 'VALIDATION_BIRTH_DATE_UNDERAGE',
  VALIDATION_INVALID_ORGANIZATION = 'VALIDATION_INVALID_ORGANIZATION',
  VALIDATION_DUPLICATE_VALUE = 'VALIDATION_DUPLICATE_VALUE',
  VALIDATION_INVALID_FORMAT_LOWERCASE = 'VALIDATION_INVALID_FORMAT_LOWERCASE',
  VALIDATION_INVALID_FORMAT_UPPERCASE = 'VALIDATION_INVALID_FORMAT_UPPERCASE',
  VALIDATION_PASSWORD_MISMATCH = 'VALIDATION_PASSWORD_MISMATCH',
  VALIDATION_PASSWORD_REUSED = 'VALIDATION_PASSWORD_REUSED',
  VALIDATION_RESET_TOKEN_INVALID = 'VALIDATION_RESET_TOKEN_INVALID',
  VALIDATION_OTT_EXPIRED = 'VALIDATION_OTT_EXPIRED',
  VALIDATION_INVALID_FIELDS = 'VALIDATION_INVALID_FIELDS',
  VALIDATION_ACCESS_DENIED = 'VALIDATION_ACCESS_DENIED',
  VALIDATION_MALFORMED = 'VALIDATION_MALFORMED',
  VALIDATION_MODEL_NOTFOUND = 'VALIDATION_MODEL_NOTFOUND',
  VALIDATION_INVALID_TYPE = 'VALIDATION_INVALID_TYPE',
  VALIDATION_ERROR_PROCESSING = 'VALIDATION_ERROR_PROCESSING',
  VALIDATION_BAD_REQUEST = 'VALIDATION_BAD_REQUEST',
  VALIDATION_PAYLOAD_TOO_LARGE = 'VALIDATION_PAYLOAD_TOO_LARGE',
  VALIDATION_UNSUPPORTED_MEDIA_TYPE = 'VALIDATION_UNSUPPORTED_MEDIA_TYPE',
  // Business
  BUSINESS_USER_NOT_FOUND = 'BUSINESS_USER_NOT_FOUND',
  BUSINESS_DEVICE_NOT_FOUND = 'BUSINESS_DEVICE_NOT_FOUND',
  BUSINESS_INGESTION_NOT_FOUND = 'BUSINESS_INGESTION_NOT_FOUND',
  BUSINESS_MAINTENANCE_ORDER_NOT_FOUND = 'BUSINESS_MAINTENANCE_ORDER_NOT_FOUND',
  BUSINESS_UNAUTHORIZED_ADMIN_UPDATE_ORGANIZATION = 'BUSINESS_UNAUTHORIZED_ADMIN_UPDATE_ORGANIZATION',
  BUSINESS_ERROR_UPDATING_ORGANIZATION = 'BUSINESS_ERROR_UPDATING_ORGANIZATION',
  BUSINESS_DEVICE_NOT_FOUND_IN_ORGANIZATION = 'BUSINESS_DEVICE_NOT_FOUND_IN_ORGANIZATION',
  BUSINESS_ORGANIZATION_NOT_FOUND = 'BUSINESS_ORGANIZATION_NOT_FOUND',
  BUSINESS_DEVICE_ALREADY_ASSIGNED = 'BUSINESS_DEVICE_ALREADY_ASSIGNED_TO_ORGANIZATION',
  BUSINESS_DEVICE_NOT_LINKED_TO_ORGANIZATION = 'BUSINESS_DEVICE_NOT_LINKED_TO_ORGANIZATION',
  BUSINESS_DEVICE_MODEL_NOT_FOUND = 'BUSINESS_DEVICE_MODEL_NOT_FOUND',
  BUSINESS_CONFLICT_ON_DELETE_USER = 'BUSINESS_CONFLICT_ON_DELETE_USER',
  BUSINESS_DEVICE_SERIAL_EXISTS = 'BUSINESS_DEVICE_SERIAL_EXISTS',
  BUSINESS_USER_ALREADY_ACTIVE = 'BUSINESS_USER_ALREADY_ACTIVE',
  BUSINESS_ADMIN_NOT_FOUND_FOR_ORGANIZATION = 'BUSINESS_ADMIN_NOT_FOUND_FOR_ORGANIZATION',
  BUSINESS_CANNOT_REMOVE_LAST_ADMIN = 'BUSINESS_CANNOT_REMOVE_LAST_ADMIN',
  BUSINESS_ERROR_REMOVING_ADMIN_ROLE = 'BUSINESS_ERROR_REMOVING_ADMIN_ROLE',
  BUSINESS_USER_NOT_IN_ALLOWED_ORG = 'BUSINESS_USER_NOT_IN_ALLOWED_ORG',
  BUSINESS_USER_ALREADY_ADMIN = 'BUSINESS_USER_ALREADY_ADMIN',
  BUSINESS_ONLY_MARSI = 'BUSINESS_ONLY_MARSI',
  BUSINESS_SESSION_NOT_FOUND = 'BUSINESS_SESSION_NOT_FOUND',
  // nuevo en ErrorCode (Business)
  BUSINESS_CONFLICT_ON_DELETE_DEVICE = 'BUSINESS_CONFLICT_ON_DELETE_DEVICE',
  BUISNESS_USER_NOT_PENDING = 'BUISNESS_USER_NOT_PENDING',
  BUSINESS_INVALID_CREATOR = 'BUSINESS_INVALID_CREATOR',
  BUSINESS_CONFLICT_ON_DELETE_ORGANIZATION = 'BUSINESS_CONFLICT_ON_DELETE_ORGANIZATION',
  BUSINESS_NOT_CONFIG_PRIVACY_SETTINGS = 'BUSINESS_NOT_CONFIG_PRIVACY_SETTINGS',
  BUSINESS_ERROR_PRIVACY_SETTINGS = 'BUSINESS_ERROR_PRIVACY_SETTINGS',

  // External
  EXTERNAL_API_ERROR = 'EXTERNAL_API_ERROR',
  EXTERNAL_API_TIMEOUT = 'EXTERNAL_API_TIMEOUT',

  // Database
  DATABASE_CONNECTION_ERROR = 'DATABASE_CONNECTION_ERROR',

  // Network — generados también desde el frontend
  NETWORK_TIMEOUT = 'NETWORK_TIMEOUT',
  NETWORK_ERROR = 'NETWORK_ERROR',

  // System
  SYSTEM_INTERNAL_ERROR = 'SYSTEM_INTERNAL_ERROR',
  // Dashboard
  BUSINESS_DASHBOARD_ALREADY_EXISTS = 'BUSINESS_DASHBOARD_ALREADY_EXISTS',
  BUSINESS_CONFLICT_ON_DELETE_DASHBOARD = 'BUSINESS_CONFLICT_ON_DELETE_DASHBOARD',
  BUSINESS_DASHBOARD_NOT_FOUND = 'BUSINESS_DASHBOARD_NOT_FOUND',
  BUSINESS_DASHBOARD_FAILED_QUERY = 'BUSINESS_DASHBOARD_FAILED_QUERY',
  // Patients
  BUSINESS_PATIENT_NOT_FOUND = 'BUSINESS_PATIENT_NOT_FOUND',
  SYNC_PATIENTS_UPLOAD_FAILED = 'SYNC_PATIENTS_UPLOAD_FAILED',
  SYNC_PATIENTS_DOWNLOAD_FAILED = 'SYNC_PATIENTS_DOWNLOAD_FAILED',
  SYNC_PATIENT_VERSION_TOO_LOW = 'SYNC_PATIENT_VERSION_TOO_LOW',
  SYNC_ERROR_DELETING_PATIENT = 'SYNC_ERROR_DELETING_PATIENT',
  SYNC_NOT_IN_ORG = 'SYNC_NOT_IN_ORG',
  BUSINESS_ERROR_DELETING_PATIENT = 'BUSINESS_ERROR_DELETING_PATIENT',

  SYNC_DEVICES_DOWNLOAD_FAILED = 'SYNC_DEVICES_DOWNLOAD_FAILED',
  SYNC_SESSIONS_UPLOAD_FAILED = 'SYNC_SESSIONS_UPLOAD_FAILED',
  // RPS
  RPS_UNAVAILABLE = 'RPS_UNAVAILABLE',
  RPS_ERROR = 'RPS_ERROR',
  RPS_COMPONENT_OUT_OF_SERVICE = 'RPS_COMPONENT_OUT_OF_SERVICE',
  RPS_EMAIL_NOT_FOUND = 'RPS_EMAIL_NOT_FOUND',
  RPS_NOT_COMPONENT = 'RPS_NOT_COMPONENT',
  RPS_NOT_FOUND = 'RPS_NOT_FOUND',
  RPS_NOT_CLOSED = 'RPS_NOT_CLOSED',
  RPS_IDENTIFIER_REQUIRED = 'RPS_IDENTIFIER_REQUIRED',
  RPS_FIELDS_INVALID = 'RPS_FIELDS_INVALID',
  RPS_NOT_COMPONENT_ASSOCIATED = 'RPS_NOT_COMPONENT_ASSOCIATED',
  RPS_OTHER_TEAM = 'RPS_OTHER_TEAM',
  RPS_INVALID_OM_CLOSED = 'RPS_INVALID_OM_CLOSED',
  RPS_OM_CANT_CLOSED = 'RPS_OM_CANT_CLOSED',
  RPS_OM_NOT_STATUS = 'RPS_OM_NOT_STATUS',

  //ota
  BUSINESS_OTA_BAD_REQUEST = 'BUSINESS_OTA_BAD_REQUEST',
  BUSINESS_OTA_NOT_VALID = 'BUSINESS_OTA_NOT_VALID',
  BUSINESS_OTA_UPLOAD_FAILED = 'BUSINESS_OTA_UPLOAD_FAILED',
  BUSINESS_OTA_METADATA_INVALID = 'BUSINESS_OTA_METADATA_INVALID',
  BUSINESS_OTA_NAME_INVALID = 'BUSINESS_OTA_NAME_INVALID',
  BUSINESS_OTA_EXISTS_VERSION = 'BUSINESS_OTA_EXISTS',
  BUSINESS_OTA_NEW_VERSION = 'BUSINESS_OTA_NEW_VERSION',
  BUSINESS_OTA_NOT_FOUND = 'BUSINESS_OTA_NOT_FOUND',
  BUSINESS_OTA_RANGE_INVALID = 'BUSINESS_OTA_RANGE_INVALID',
  // Surveys
  BUSINESS_NOT_FOUND = 'BUSINESS_NOT_FOUND',
  BUSINESS_USER_NOT_SUBSCRIBED = 'BUSINESS_USER_NOT_SUBSCRIBED',
  RPS_USER_NOT_FOUND = 'RPS_USER_NOT_FOUND',
  RPS_EMPLOYEE_NOT_FOUND = 'RPS_EMPLOYEE_NOT_FOUND',
  RPS_COMPONENT_NOT_FOUND = 'RPS_COMPONENT_NOT_FOUND',
  RPS_USER_REQUIRED_CODE = 'RPS_USER_REQUIRED_CODE',
  RPS_INCIDENCE_NOT_FOUND = 'RPS_INCIDENCE_NOT_FOUND',
  RPS_OM_NOT_MATCH = 'RPS_OM_NOT_MATCH',
  RPS_SOLUTION_NOT_FOUND = 'RPS_SOLUTION_NOT_FOUND',
}

export type PublicErrorParam = string | number | boolean;

export type PublicErrorParams = Record<string, PublicErrorParam>;

export interface ApiErrorResponse {
  code: ErrorCode;
  correlationId: string;
  params?: PublicErrorParams;
}
